import type { StatusTone } from "../data-display/StatusBadge";

export interface Sequence {
  id: string;
  workspace_id: string;
  name: string;
  description?: string | null;
  active: boolean;
  exit_on_reply: boolean;
  created_at: string;
}

export interface SequenceStep {
  id: string;
  sequence_id: string;
  position: number;
  delay_days: number;
  channel: string;
  subject?: string | null;
  body: string;
}

export interface SequenceEnrollment {
  id: string;
  sequence_id: string;
  contact_id: number;
  status: string;
  current_step: number;
  next_run_at?: string | null;
  enrolled_at: string;
  exit_reason?: string | null;
}

export const STEP_CHANNELS = [
  { value: "email", label: "Email" },
  { value: "sms", label: "Text message" },
  { value: "call", label: "Call" },
  { value: "task", label: "Task" },
] as const;

export const stepChannelLabel = (value?: string) =>
  STEP_CHANNELS.find((c) => c.value === value)?.label ?? value ?? "";

export const ENROLLMENT_STATUS_TONES: Record<string, StatusTone> = {
  active: "info",
  completed: "success",
  // An exit is a GOOD outcome, the customer answered, so it reads as success
  // rather than as the neutral "someone stopped this" that cancelled means.
  exited: "success",
  cancelled: "neutral",
};

export const ENROLLMENT_STATUS_LABELS: Record<string, string> = {
  active: "Active",
  completed: "Finished",
  exited: "Replied",
  cancelled: "Cancelled",
};
